<template>
  <div class="page-content">
    <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 class="mb-sm-0">Reporting</h4>

            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item">
                  <Link href="/admin/reporting">Reporting</Link>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- end page title -->

      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between">
                <div>
                  <h4 class="card-title">Reporting</h4>
                  <p class="card-title-desc mb-0">Menampilkan output data kedalam pdf atau Excell.</p>
                </div>
              </div>

              <hr />

              <div class="row">
                <div class="col-md-4">
                  <div class="card border">
                    <div class="card-header">
                      Luas Areal Perkebunan Rakyat
                    </div>
                    <div class="card-body">
                      <p class="card-text fst-italic">Pilih format cetakan dapat pdf untuk langsung melihat atau excel download terlebih dahulu.</p>
                      <a :href="luas_areal_perkebunan + '.pdf'" target="_blank" class="btn btn-outline-primary me-2">PDF</a>
                      <a :href="luas_areal_perkebunan + '.xlsx'" target="_blank" class="btn btn-outline-success">EXCEL</a>
                    </div>
                  </div>


                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <!-- end row -->
    </div>
    <!-- container-fluid -->
  </div>
</template>

<script>
import Layout from '@/layout/Index'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'

export default {
  layout: Layout,
  props: {
    luas_areal_perkebunan: String
  },
}
</script>
